import React from "react";
import { SocialMediaIconProps } from "./socialMedia.types";

// ============================================
// Facebook Icon Variants
// ============================================

const FacebookOriginal = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_fb_original)">
      <path d="M23.9991 12.075C23.9991 5.406 18.6261 0 11.9991 0C5.36909 0.0015 -0.00390625 5.406 -0.00390625 12.0765C-0.00390625 18.102 4.38509 23.097 10.1211 24.003V15.5655H7.07609V12.0765H10.1241V9.414C10.1241 6.3885 11.9166 4.7175 14.6571 4.7175C15.9711 4.7175 17.3436 4.953 17.3436 4.953V7.923H15.8301C14.3406 7.923 13.8756 8.8545 13.8756 9.81V12.075H17.2026L16.6716 15.564H13.8741V24.0015C19.6101 23.0955 23.9991 18.1005 23.9991 12.075Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_fb_original">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const FacebookOutlined = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M17 2H14C11.2386 2 9 4.23858 9 7V10H6V14H9V22H13V14H16L17 10H13V7C13 6.44772 13.4477 6 14 6H17V2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FacebookRounded = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM13.5439 4.90039C11.7912 4.90049 10.2959 6.48662 10.2959 8.55762V10.8076H8.25V13.8076H10.2959V19.8076H13.0225V13.8076H15.0684L15.75 10.8076H13.0225V8.55762C13.0225 8.14357 13.3277 7.80788 13.7041 7.80762H15.75V4.9834C15.7433 4.98275 14.8815 4.90039 13.5439 4.90039Z" fill="currentColor"/>
  </svg>
);

const FacebookSquared = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.2692 1.5C21.0535 1.5 22.5 2.94646 22.5 4.73077V19.2692C22.5 21.0535 21.0535 22.5 19.2692 22.5H4.73077C2.94646 22.5 1.5 21.0535 1.5 19.2692V4.73077C1.5 2.94646 2.94646 1.5 4.73077 1.5H19.2692ZM14.19 5.37203C13.1462 5.36144 11.8192 5.61067 10.8892 6.54788C9.94313 7.50125 9.56478 8.61895 9.54636 10.3539C9.54134 10.856 9.54636 11.9004 9.54636 11.9004H7.14754V15.1194H9.54636V22.4998H13.1512V15.1194H16.0154L16.4656 11.9004H13.1512C13.1512 11.9004 13.1462 10.2179 13.1512 9.74749C13.1512 9.17291 13.9182 8.36893 14.9928 8.36893C15.6498 8.3756 16.8356 8.36528 16.846 8.36519V5.63923C16.8342 5.63712 15.4266 5.38481 14.19 5.37203Z" fill="currentColor"/>
  </svg>
);

export default function FacebookCircle({ variant = "original", ...props }: SocialMediaIconProps) {
  switch (variant) {
    case "outlined": return <FacebookOutlined {...props} />;
    case "rounded": return <FacebookRounded {...props} />;
    case "squared": return <FacebookSquared {...props} />;
    case "original":
    default: return <FacebookOriginal {...props} />;
  }
}
